<template>
    <div
        v-if="invitations"
        class="container-fluid userGroupInvitationsWrapper">
        <div class="d-block d-lg-flex justify-content-between mb-3">
            <div class="d-block d-lg-flex flex-wrap align-items-start">
                <div class="mt-2 mb-2 mb-md-0">
                    <div class="input-group input-group-sm">
                        <input
                            v-model="search.freeword"
                            @blur="onChangeSearchFreeword"
                            type="text"
                            class="form-control"
                            placeholder="フリーワード">
                        <div class="input-group-append">
                            <div
                                class="input-group-text"
                                @click="onChangeSearchFreeword">
                                検索
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                    <div class="input-group input-group-sm">
                        <select
                            v-model="search.plan_id"
                            @change="onChangeSearchPlanId"
                            id="status"
                            class="form-control inputSearchPlanId">
                            <option :value="null">サービスで検索</option>
                            <option
                                v-for="plan in group.plans"
                                :value="plan.id">
                                {{ plan.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                    <div class="input-group input-group-sm">
                        <select
                            v-model="search.child_group_id"
                            @change="onChangeSearchChildGroupId"
                            id="status"
                            class="form-control inputSearchPlanId">
                            <option :value="null">所属{{ childGroupName }}で検索</option>
                            <option
                                v-for="group in group.child_groups"
                                :value="group.id">
                                {{ group.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                    <div class="input-group input-group-sm">
                        <select
                            v-model="search.status"
                            @change="onChangeSearchStatus"
                            id="status"
                            class="form-control inputSearchStatus">
                            <option :value="null">ステータスで検索</option>
                            <option
                                v-for="status in invitationStatus.all"
                                :value="status.value">
                                {{ status.text }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="d-block d-lg-flex align-items-center">
                    <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                        <span class="small">発行日時</span>
                    </div>
                    <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="search.first_invited_at_gte"
                                @change="onChangeSearchFirstInvitedAtGte"
                                type="date"
                                class="form-control">
                        </div>
                    </div>
                    <span class="small mt-2 ml-2">〜</span>
                    <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="search.first_invited_at_lte"
                                @change="onChangeSearchFirstInvitedAtLte"
                                type="date"
                                class="form-control">
                        </div>
                    </div>
                </div>

                <div class="d-block d-lg-flex align-items-center">
                    <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                        <span class="small">メール再送信日時</span>
                    </div>
                    <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="search.send_at_gte"
                                @change="onChangeSearchSendAtGte"
                                type="date"
                                class="form-control">
                        </div>
                    </div>
                    <span class="small mt-2 ml-2">〜</span>
                    <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="search.send_at_lte"
                                @change="onChangeSearchSendAtLte"
                                type="date"
                                class="form-control">
                        </div>
                    </div>
                </div>

                <template v-if="canDoctorPass">
                    <div class="d-block d-lg-flex align-items-center">
                        <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                            <span class="small">出国日</span>
                        </div>
                        <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                            <div class="input-group input-group-sm">
                                <input
                                    v-model="search.period_start"
                                    @change="onChangeSearchPeriodStart"
                                    type="date"
                                    class="form-control">
                            </div>
                        </div>
                    </div>

                    <div class="d-block d-lg-flex align-items-center">
                        <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                            <span class="small">帰国日</span>
                        </div>
                        <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                            <div class="input-group input-group-sm">
                                <input
                                    v-model="search.period_end"
                                    @change="onChangeSearchPeriodEnd"
                                    type="date"
                                    class="form-control">
                            </div>
                        </div>
                    </div>
                </template>
            </div>

            <div class="d-flex mt-2">
                <b-button
                    class="ml-0 mr-2"
                    style="height:36px; width:150px;"
                    variant="yokumiru-orange"
                    size="sm"
                    :disabled="!hasInviting"
                    @click="resendAllGroupInvitation">
                    一括メール再送信
                </b-button>
                <b-button
                    style="height:36px; width:150px;"
                    variant="yokumiru-orange"
                    size="sm"
                    @click="downloadCSV"
                    :disabled="inProgress">
                    CSVダウンロード
                </b-button>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-md-12">
                <b-table
                    striped
                    hover
                    responsive
                    :items="invitations"
                    :fields="fields"
                    :sort-by.sync="morphState.sortBy"
                    :sort-desc.sync="morphState.sortDesc"
                    @sort-changed="fetchInvitations"
                    class="table-bordered m-table">
                    <template v-slot:cell(join_users.full_name_kana)="data">
                        <template v-if="data.item.user">
                            <div>{{ data.item.user.full_name }}</div>
                            <div class="small">{{ data.item.user.full_name_kana }}</div>
                            <span class="text-muted small">#{{ data.item.user_id }}</span>
                        </template>
                        <template v-else-if="data.item.status !== invitationStatus.inviting">
                            <span class="text-muted">退会済の{{ $locale.patient }}</span>
                        </template>
                        <template v-else-if="data.item.last_name + data.item.first_name">
                            <div>{{ data.item.last_name}} {{data.item.first_name }}</div>
                        </template>
                        <template v-else>
                            <span class="text-muted">未登録</span>
                        </template>
                    </template>

                    <template v-slot:cell(plan_id)="data">
                        <div>{{ data.item.plan.name }}</div>
                        <div
                            v-if="helper.isDoctorPass(data.item.plan)"
                            class="text-muted">
                            <span class="u-palt">渡航期間:</span>
                            <span class="u-palt">
                                {{ helper.dateForHuman(data.item.period_start, timezone, { exceptYear: helper.isCurrentYear(data.item.period_start, timezone), simpleYear: true }) }}
                            </span>
                            <span>-</span>
                            <span class="u-palt">
                                {{ helper.dateForHuman(data.item.period_end, timezone, { exceptYear: helper.isCurrentYear(data.item.period_end, timezone), simpleYear: true }) }}
                            </span>
                            <span class="period-length text-muted">({{calcSubscriptionPeriod(data.item.period_start, data.item.period_end)}}日間)</span>
                        </div>
                    </template>

                    <template v-slot:cell(child_group_id)="data">
                        <div v-if="data.item.child_group === null">-</div>
                        <div v-else>
                            <a :href="`/${groupTypeModel}/groups/${data.item.child_group.id}`">
                                <b-icon-building/>
                                <span>{{ data.item.child_group.name }}</span>
                            </a>
                        </div>
                    </template>

                    <template v-slot:cell(is_authorizer)="data">
                        <div v-if="data.item.child_group === null">-</div>
                        <div v-else>{{ data.item.is_authorizer ? '設定する' : '設定しない' }}</div>
                    </template>

                    <template v-slot:cell(status)="data">
                        <div
                            v-if="data.item.status === invitationStatus.done"
                            class="text-success">
                            {{ data.item.status_label }}
                        </div>
                        <div 
                            v-else-if="data.item.deleted_at"
                            class="text-muted">
                            キャンセル済み
                        </div>
                        <div
                            v-else
                            class="text-muted">
                            {{ data.item.status_label }}
                        </div>
                        <div v-if="data.item.status === invitationStatus.done && data.item.verified_at" class="text-muted small">
                            {{ `参加日時: ${helper.dateTimeForHuman(data.item.verified_at, timezoneAsia)}` }}
                        </div>
                    </template>

                    <template v-slot:cell(first_invited_at)="data">
                        {{ helper.dateTimeForHuman(data.item.first_invited_at, timezoneAsia) }}
                    </template>

                    <template v-slot:cell(send_at)="data">
                        <div v-if="data.item.send_at && data.item.first_invited_at !== data.item.send_at">
                            {{ helper.dateTimeForHuman(data.item.send_at, timezoneAsia) }}
                        </div>
                        <div v-else class="text-muted">-</div>
                    </template>

                    <template v-slot:cell(deleted_at)="data">
                        <div v-if="data.item.deleted_at">
                            {{ helper.dateTimeForHuman(data.item.deleted_at, timezoneAsia) }}
                        </div>
                        <div v-else class="text-muted">-</div>
                    </template>

                    <template v-slot:cell(links)="data">
                        <div class="text-center">
                            <div>
                                <b-button
                                    v-if="data.item.status === invitationStatus.inviting && !data.item.deleted_at"
                                    size="sm"
                                    variant="yokumiru-orange"
                                    :disabled="inProgress"
                                    @click="resendGroupInvitation(data.item)">
                                    メール再送信
                                </b-button>
                                <b-button
                                    v-if="canCancel(data.item)"
                                    class="btnCancel"
                                    size="sm"
                                    variant="yokumiru-gray"
                                    :disabled="inProgress"
                                    @click="openModalGroupInvitationCancel(data.item)">
                                    キャンセル
                                </b-button>
                            </div>
                            
                        </div>
                    </template>
                </b-table>

                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <b-pagination
                        :total-rows="morphState.total"
                        :per-page="morphState.per_page"
                        v-model="morphState.current_page"
                        @change="fetchInvitations">
                    </b-pagination>

                    <div class="d-flex flex-wrap align-items-center">
                        <div class="mr-3 mb-3">
                            <span class="small">{{ dispPaginationDetail }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <doctor-menu-modal user-type="user"/>
        <doctor-profile-modal/>
        <admin-group-invitation-cancel-modal :group="group"/>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'
import moment from "moment-timezone";

export default {
    props: {
        timezone: {
            type: String,
            default: 'Asia/Tokyo',
        },
        group: {
            type: Object,
            required: true,
        },
        childGroupName: {
            type: String,
            default: '法人',
        },
        canDoctorPass: {
            type: Boolean,
            default: false,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            search: {
                freeword: null,
                plan_id: null,
                child_group_id: null,
                status: null,
                first_invited_at_gte: null,
                first_invited_at_lte: null,
                send_at_gte: null,
                send_at_lte: null,
                period_start: null,
                period_end: null,
            },
            invitations: null,
            invitationStatus: constants.groupInvitations,
            inProgress: false,
            errors: {},
            fields: [
                {
                    key: 'email',
                    label: 'メールアドレス',
                    sortable: true,
                },
                {
                    key: 'join_users.full_name_kana',
                    label: `${this.$locale.patient}名`,
                    sortable: true,
                },
                {
                    key: 'plan_id',
                    label: 'サービス',
                    sortable: true,
                },
                {
                    key: 'child_group_id',
                    label: `所属${this.childGroupName}`,
                    sortable: true,
                },
                {
                    key: 'is_authorizer',
                    label: `${this.childGroupName}担当者`,
                    sortable: false,
                },
                {
                    key: 'status',
                    label: 'ステータス',
                    sortable: true,
                },
                {
                    key: 'first_invited_at',
                    label: '発行日時',
                    sortable: true,
                },
                {
                    key: 'send_at',
                    label: 'メール再送信日時',
                    sortable: true,
                },
                {
                    key: 'deleted_at',
                    label: 'キャンセル日時',
                    sortable: true,
                },
                {
                    key: 'links',
                    label: '',
                    sortable: false,
                },
            ],
        }
    },

    computed: {
        hasInviting: function () {
            return this.invitations.some((invitation) => {
                return invitation.status === this.invitationStatus.inviting && !invitation.deleted_at
            })
        },

        timezoneAsia: function () {
            return 'Asia/Tokyo'
        },

        isCompany: function () {
            return this.helper.isCompany(this.group)
        },

        isOrganization: function () {
            return this.helper.isOrganization(this.group)
        },

        morphState: function () {
            if (this.isCompany) {
                return this.$store.state.adminCompanyInvitations
            }
            else if (this.isOrganization) {
                return this.$store.state.adminOrganizationInvitations
            }
            return null
        },

        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if (this.morphState.total < 1) return ''
            return `全${this.morphState.total}件中 ${this.morphState.from}～${this.morphState.to}件表示`
        },

        groupTypeModel: function () {
            if (!this.group) return ''
            return this.helper.groupTypeModel(this.group.group_type)
        },
    },

    created: function () {
        this.initQueryFromState()
        this.initSearchCondition()
        this.fetchInvitations()

        bus.$on('group-invitation-canceled', this.fetchInvitations)
    },

    beforeDestroy: function () {
        bus.$off('group-invitation-canceled')
    },

    methods: {
        ...mapMutations({
            setQueryCompany: 'adminCompanyInvitations/setQuery',
            setQueriesCompany: 'adminCompanyInvitations/setQueries',
            clearQueriesCompany: 'adminCompanyInvitations/clearQueries',
            setQueryOrganization: 'adminOrganizationInvitations/setQuery',
            setQueriesOrganization: 'adminOrganizationInvitations/setQueries',
            clearQueriesOrganization: 'adminOrganizationInvitations/clearQueries',
        }),

        setQuery: function (data) {
            if (this.isOrganization) {
                this.setQueryOrganization(data)
            }
            else if (this.isCompany) {
                this.setQueryCompany(data)
            }
        },

        setQueries: function (data) {
            if (this.isOrganization) {
                this.setQueriesOrganization(data)
            }
            else if (this.isCompany) {
                this.setQueriesCompany(data)
            }
        },

        clearQueries: function () {
            if (this.isOrganization) {
                this.clearQueriesOrganization()
            }
            else if (this.isCompany) {
                this.clearQueriesCompany()
            }
        },

        /**
         * 検索条件の初期化
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (this.isCompany && data.adminCompanyInvitations) {
                    this.setQueries(data.adminCompanyInvitations)
                }
                else if (this.isOrganization && data.adminOrganizationInvitations) {
                    this.setQueries(data.adminOrganizationInvitations)
                }
            }
        },

        /**
         * 検索条件の初期化
         */
        initSearchCondition: function () {
            this.search.freeword = this.morphState.freeword
            this.search.plan_id = this.morphState.plan_id
            this.search.child_group_id = this.morphState.child_group_id
            this.search.status = this.morphState.status
            this.search.first_invited_at_gte = this.morphState.first_invited_at_gte
            this.search.first_invited_at_lte = this.morphState.first_invited_at_lte
            this.search.send_at_gte = this.morphState.send_at_gte
            this.search.send_at_lte = this.morphState.send_at_lte
            this.search.period_start = this.morphState.period_start
            this.search.period_end = this.morphState.period_end
        },

        onChangeSearchFreeword: async function () {
            await this.setQuery({ key: 'freeword', value: this.search.freeword })
            await this.fetchInvitations(1)
        },

        onChangeSearchPlanId: async function () {
            await this.setQuery({ key: 'plan_id', value: this.search.plan_id })
            await this.fetchInvitations(1)
        },

        onChangeSearchChildGroupId: async function () {
            await this.setQuery({ key: 'child_group_id', value: this.search.child_group_id })
            await this.fetchInvitations(1)
        },

        onChangeSearchStatus: async function () {
            await this.setQuery({ key: 'status', value: this.search.status })
            await this.fetchInvitations(1)
        },

        onChangeSearchFirstInvitedAtGte: async function () {
            await this.setQuery({ key: 'first_invited_at_gte', value: this.search.first_invited_at_gte })
            await this.fetchInvitations(1)
        },

        onChangeSearchFirstInvitedAtLte: async function () {
            await this.setQuery({ key: 'first_invited_at_lte', value: this.search.first_invited_at_lte })
            await this.fetchInvitations(1)
        },

        onChangeSearchSendAtGte: async function () {
            await this.setQuery({ key: 'send_at_gte', value: this.search.send_at_gte })
            await this.fetchInvitations(1)
        },

        onChangeSearchSendAtLte: async function () {
            await this.setQuery({ key: 'send_at_lte', value: this.search.send_at_lte })
            await this.fetchInvitations(1)
        },

        onChangeSearchPeriodStart: async function () {
            await this.setQuery({ key: 'period_start', value: this.search.period_start })
            await this.fetchInvitations(1)
        },

        onChangeSearchPeriodEnd: async function () {
            await this.setQuery({ key: 'period_end', value: this.search.period_end })
            await this.fetchInvitations(1)
        },

        /**
         * ドクターパス利用一覧取得
         *
         * @param {number|object} param
         */
        fetchInvitations: async function (param = null) {
            if (this.inProgress) return
            this.inProgress = true

            this.invitations = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.admin.groups.endpoint.base

            await axios.get(`${endpoint}/${this.group.id}/invitations${this.buildQuery()}`)
                .then(({data}) => {
                    this.invitations = data.data
                    this.setQueries(data.meta)
                })
                .catch(({response}) => {
                    if (response.status === 422) {
                        this.clearQueries()
                    }
                })

            this.inProgress = false
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            const state = this.morphState

            if (paginate) {
                query += `page=${state.current_page}`
                query += `&sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`
            }
            else {
                query += `sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`
            }

            if (state.freeword) {
                query += `&freeword=${state.freeword}`
            }
            if (state.child_group_id) {
                query += `&child_group_id=${state.child_group_id}`
            }
            if (state.plan_id) {
                query += `&plan_id=${state.plan_id}`
            }
            if (state.status) {
                query += `&status=${state.status}`
            }
            if (state.first_invited_at_gte) {
                query += `&first_invited_at_gte=${state.first_invited_at_gte}`
            }
            if (state.first_invited_at_lte) {
                query += `&first_invited_at_lte=${state.first_invited_at_lte}`
            }
            if (state.send_at_gte) {
                query += `&send_at_gte=${state.send_at_gte}`
            }
            if (state.send_at_lte) {
                query += `&send_at_lte=${state.send_at_lte}`
            }

            if (this.canDoctorPass) {
                if (state.period_start) {
                    query += `&period_start=${state.period_start}`
                }
                if (state.period_end) {
                    query += `&period_end=${state.period_end}`
                }
            }

            return query
        },

        /**
         * 利用アカウント発行のキャンセル可能判定
         * @param {object} invitation
         * @return {boolean}
         */
        canCancel: function (invitation) {
            if (invitation.verified_at !== null || !this.helper.isDoctorPass(invitation.plan) || invitation.deleted_at) {
                return false
            }
            const periodStart = moment(invitation.period_start)
            return moment().isBefore(periodStart)
        },

        /**
         * 利用アカウント発行のキャンセル
         * @param {object} invitation
         */
        openModalGroupInvitationCancel: async function (invitation) {
            bus.$emit('open-modal-authorizer-group-invitation-cancel', invitation)
        },

        /**
         * CSVダウンロード
         */
        downloadCSV: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = `${constants.admin.groups.endpoint.base}/${this.group.id}/invitations/export${this.buildQuery(false)}`
            const options = { responseType : 'blob' }

            await axios.get(endpoint, options)
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: response.data.type,
                    })
                    saveAs(
                        blob,
                        sprintf(
                            '%s_利用アカウント発行状況一覧_%s.csv',
                            this.group.name,
                            moment().format('YYYYMMDD')
                        )
                    )
                })
                .catch(() => {
                    bus.$emit('alert-danger', 'システムエラーが発生しました。')
                })

            this.inProgress = false
        },

        calcSubscriptionPeriod(ps, pe) {
            const length = moment(pe).diff(moment(ps), 'days')

            return length + 1
        },

        /**
         * 利用アカウント発行メールの再送信
         * @param {object} invitation
         */
         resendGroupInvitation: async function (invitation) {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.groups.endpoint.base

            await axios.post(`${endpoint}/${this.group.id}/invitations/${invitation.id}/resend`, invitation)
                .then(() => {
                    bus.$emit('alert-success', `利用アカウント発行メールを ${invitation.email} に再送信しました。`)
                })
                .catch(() => {
                    bus.$emit('alert-danger', 'システムエラーが発生しました。')
                })

            this.inProgress = false
            await this.fetchInvitations()
        },

        /**
         * 利用アカウント発行メールの一括再送信
         * @param {object} invitation
         */
         resendAllGroupInvitation: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.groups.endpoint.base

            await axios.post(`${endpoint}/${this.group.id}/invitations/resend_all`)
                .then(() => {
                    bus.$emit('alert-success', `利用アカウント発行メールを一括再送信しました。`)
                })
                .catch(() => {
                    bus.$emit('alert-danger', 'システムエラーが発生しました。')
                })

            this.inProgress = false
            await this.fetchInvitations()
        },
    },
}
</script>

<style lang="scss" scoped>
.btnCancel {
    margin-top: 4px;
    min-width: 94px;
}

.inputSearchPlanId {
    max-width: 150px;

    @media screen and (max-width:991px) {
        max-width: 100%;
    }
}

.inputSearchStatus {
    max-width: 140px;

    @media screen and (max-width:991px) {
        max-width: 100%;
    }
}

.repeatReservedLabel {
    position: relative;
    top: -1px;
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    color: #fff;
    font-size: 10px;
    text-align: center;
    background-color: #e7a222;
    border-radius: 50%;
}

.invitationTime {
    color: #464a4d;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.4;
    font-feature-settings: 'palt';

    span:last-child {
        color: #6e7275;
        font-weight: normal;
    }
}

.doctorMenuHealthPackageIcon {
    margin: 3px 0 1px;

    img {
        width: 130px;
    }
}

.feedbackLabel {
    width: 90px;
    margin: 0 auto;
    padding: 3px 0;
    border-radius: 20px;
    color: #fff;
    font-size: 13px;
    text-align: center;
    box-sizing: border-box;
}

.feedbackNextSchedule {
    overflow-x: scroll;
    white-space: pre;
    width: 160px;
    padding: 0 0 5px;
}

.period-length {
    font-size: 13px;
    text-align: end;
    white-space: nowrap
}
</style>

<style lang="scss">
.userGroupInvitationsWrapper {
    table {
        min-width: 1400px;

        th, td {
            font-size: 0.75rem;
        }

        th {
            &:nth-child(9) {
                width: 140px;
            }

            &:nth-child(10) {
                width: 160px;
            }
        }
    }
}
</style>
